
/**
 * **ダメージ計算**（Issue #538）。攻撃宣言（`attack`）のあと、実際にぶつかる瞬間。
 *
 * 開く: `battle`。攻撃するカードと対象の**両方**で光が弾ける（対象が無ければ直接攻撃なので
 * 攻撃側だけ）。**宣言とダメージ計算のあいだに発動・チェーンが挟まる**ので別のイベント
 * （旧 `components/fx` も `attack.js` と `strike.js` に分けている）。
 */
const COLOR = '#ffd0a0';

/** 状況ごとのファイル（`../effects/battle_<variant>_effect.js`）が共有する組み立て（Issue #628。arcade はどの状況も同じ絵） */
export const spec = {
  label: 'ダメージ計算',
  color: COLOR,
  sounds: () => [{ at: 60, name: 'attack' }],

  opens({ payload }) {
    const a = payload?.attacker;
    if (!a?.uid && !a?.zone) return null;
    // 対象が無ければ直接攻撃（`for` で回すので配列にまとめる）
    const hits = [a, payload.target].filter((c) => c?.uid || c?.zone);
    return { ...payload, hits };
  },

  layers: [
    {
      id: 'hit',
      label: 'ぶつかる光',
      part: 'glow',
      for: 'hits',
      at: { card: '{uid}', else: { zone: '{zone}' } },
      props: { color: COLOR },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.3 }, { ms: 180, value: 2.2, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 0, value: 1 }, { ms: 420, value: 0 }] },
      },
    },
    {
      id: 'clash',
      label: 'CLASH',
      part: 'text',
      at: { screen: [960, 620] },
      props: { text: 'CLASH!', size: 120, color: '#fff', strokeColor: '#5a2a00' },
      tf: {
        scale: { keys: [{ ms: 40, value: 0.7 }, { ms: 240, value: 0.5, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 40, value: 0 }, { ms: 160, value: 1 }, { ms: 560, value: 1 }, { ms: 700, value: 0 }] },
      },
    },
  ],
};
